import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  list: {
    margin: [theme.spacing(3), 0],
    padding: 0,
  },
  item: {
    fontSize: 16,
    fontWeight: 700,
    height: 64,
    padding: 0,
    borderBottomColor: theme.palette.colors.divider,
    justifyContent: 'space-between',
  },
  icon: {
    minWidth: 'unset',
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/MobileNavTabs/useStyles.js